import styled from "styled-components";
import { Link } from "react-router-dom";

export const TableLink = styled(Link)({
  color: "inherit",
  display: "block",
  textDecoration: "none",
});
